module.exports = __webpack_public_path__ + "static/media/menu-default-mobile.6442c9f0.jpg";